export default {
    black: '#282828',
    blackDark: '#121212',
    grey: '#f4f4f4',
    greyMidLight: '#BABABA',
    greyMid: '#707070',
    greyDark: '#4a4a4a',
    pureBlack: '#000000',
    white: '#ffffff',
    yellow: '#ffdc00',
    green: '#80C342',
    availability: {
        green: '#68F087',
        amber: '#FFA969',
        red: '#F84848',
    },
    validation: {
        invalid: '#da291c',
        valid: '#008c15',
    },
};
